import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

/**
 * Fade + rise on enter. `as` lets it wrap any element.
 */
export default function Reveal({
  as = 'div',
  children,
  delay = 0,
  y = 28,
  duration = 0.9,
  once = true,
  amount = 0.2,
  className,
  style,
  ...rest
}) {
  const reduce = useReducedMotion();
  const Tag = motion[as] || motion.div;

  return (
    <Tag
      className={className}
      style={style}
      initial={reduce ? false : { opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, amount }}
      transition={{ duration, delay, ease: [0.16, 1, 0.3, 1] }}
      {...rest}
    >
      {children}
    </Tag>
  );
}
